import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import ProductPageLayout from '../../components/feedpage/ProductPageLayout';
import { Helmet } from 'react-helmet';
import { getproduct_detail } from '../../services/Apis';
import { pushToDataLayer } from '../../components/utils/dataUserpush';
import { useSelector } from 'react-redux';

// --- SEO Component ---
const ProductSEO = ({ product, Webfeed }) => {
  if (!product) return null;

  const title = `Buy ${product.name || 'Product'} Online | OurShopee.com | ${product.sku || ''}`;
  const description = `Buy ${product.name || 'Product'} online at the best price from Ourshopee.com. SKU: ${product.sku || ''}. ${product.brand ? `Brand: ${product.brand}` : ''}`;
  const keywords = `${product.brand || ''} ${product.name || ''} ${product.category_name || ''} ${product.subcategory_name || ''} ${product.sku || ''}`.replace(/\s+/g, ' ').trim();
  const canonicalUrl = `https://www.ourshopee.com/feed/${product.id}/${Webfeed}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Open Graph Tags */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:site_name" content="OurShopee.com" />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={product.image || '/default-og-image.png'} />
      <meta property="og:image:width" content="800" />
      <meta property="og:image:height" content="600" />
      <meta property="og:image:alt" content={product.name || 'Product Image'} />
    </Helmet>
  );
};

// --- Main product page component ---
export default function FeedProductPage() {
  const { slug, slug1 } = useParams();
  const [searchParams] = useSearchParams();
  const [productData, setProductData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const currentcountry = useSelector((state) => state.globalslice.currentcountry);
  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const data = await getproduct_detail(slug);
        if (!data) {
          setError('Product not found');
        } else {
          setProductData(data);
          pushToDataLayer("viewed_feed_page", currentcountry.name, {
            sku_id: data?.data?.data?.product?.[0]?.sku,
            product_name: data?.data?.data?.product?.[0]?.name,
            product_price: `${currentcountry.currency} ${data?.data?.data?.product?.[0]?.display_price}`,
            source_: slug1
          });
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();
  }, [slug]);

  // Determine country from hostname
  const hostname = searchParams.get('hostname') || 'www.ourshopee.com';
  const country = hostname.split('.')[0] === 'www' ? 'uae' : hostname.split('.')[0];

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;
  if (!productData) return <div>Product not found</div>;

  return (
    <>
      <ProductSEO product={productData?.data?.data?.product?.[0]} Webfeed={slug1} />
      <ProductPageLayout
        product={productData?.data?.data?.product?.[0]}
        queryParams={Object.fromEntries(searchParams.entries())}
        country={country}
        Webfeed={slug1}
      />
    </>
  );
} 